module.exports = __webpack_public_path__ + "img/appGallery.70435f6c.png";